import { useDispatch, useSelector } from "react-redux";
import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";
import { Stack } from "@fluentui/react/lib/Stack";

import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { Flags } from "Images";
import { useCallback } from "react";
import { uiSetLanguage } from "Store/Actions";
import { selectLanguage } from "Store/Selectors/UI";
import { useLanguageStyles } from "./UseLanguageStyles";

export const Language = WithTranslator(({ translator }: IWithTranslatorProps): JSX.Element => {
  const dispatch = useDispatch();
  const LanguageStyles = useLanguageStyles();
  const currentLanguage = useSelector(selectLanguage);

  const languages = [`de`, `gb`, `fr`];

  const options: IChoiceGroupOption[] = languages.map((l) => ({
    key: l,
    text: translator.get(`settings.language.${l === `gb` ? `en` : l}`, `~${l === `gb` ? `en` : l}~`),
    imageSrc: Flags(l),
    selectedImageSrc: Flags(l),
    imageSize: { width: 32, height: 32 }
  }));

  const onChange = useCallback(
    (_, { key }: IChoiceGroupOption) => {
      dispatch(uiSetLanguage(key === `gb` ? `en` : key));
    },
    [dispatch]
  );

  return (
    <Stack horizontal className={LanguageStyles.root}>
      <ChoiceGroup
        defaultSelectedKey={currentLanguage === `en` ? `gb` : currentLanguage}
        label={`${translator.get(`settings.language.label`, `Select Language`)}...`}
        onChange={onChange}
        options={options}
      />
    </Stack>
  );
});
